import { INPUT_SETTINGS_MASK, INPUT_SETTINGS_PLACEHOLDER } from '../constants/inputSettings.js';

const getMaskInputMode = (mode = 'default') => ({
    mask: mode in INPUT_SETTINGS_MASK ? INPUT_SETTINGS_MASK[mode] : INPUT_SETTINGS_MASK.default,
    placeholder: mode in INPUT_SETTINGS_PLACEHOLDER
        ? INPUT_SETTINGS_PLACEHOLDER[mode]
        : INPUT_SETTINGS_PLACEHOLDER.default,
});

export { getMaskInputMode };
//# sourceMappingURL=getMaskByInputMode.js.map
